module.exports = __webpack_public_path__ + "img/syukyaku-de-pa003.5cece695.png";